module.exports = __webpack_public_path__ + "media/components/src/assets/images/menu_4-bb167443334f54742276562dce22779b.jpg";